import { isNetworkError } from '@shared/api/errors'

/** Report each outcome; a permission failure must not hide later deletable items. */
export async function deleteBatch<T extends { id: string }>(
  targets: readonly T[],
  remove: (item: T) => Promise<void>,
): Promise<{ deleted: string[]; failed: string[] }> {
  const deleted: string[] = []
  const failed: string[] = []
  for (const item of targets) {
    try {
      await remove(item)
      deleted.push(item.id)
    } catch (error) {
      failed.push(item.id)
      if (isNetworkError(error)) break
    }
  }
  return { deleted, failed }
}
